import { ReactNode } from 'react';
import { Button, SxProps, Typography } from '@mui/material';
import { ContentCard } from 'components/Card';
import { InfoCard } from 'components/notification-cards';
import { ButtonContainer } from './styledComponents';

interface ItemListCardProps {
  title?: string;
  titleVariant?: 'h4' | 'h5' | 'h6';
  subtitle?: string;
  isEmpty?: boolean;
  showAddButton?: boolean;
  addButtonLabel?: string;
  addButtonTestId?: string;
  onAddClick?: () => void;
  addButtonSx?: SxProps;
  emptyStateText?: string;
  infoCard?: {
    title: string;
    body: string;
  };
  sx?: SxProps;
  children?: ReactNode;
}

export const ItemListCard = ({
  title,
  titleVariant,
  subtitle,
  isEmpty = false,
  showAddButton = false,
  addButtonLabel,
  addButtonTestId,
  onAddClick,
  addButtonSx,
  emptyStateText,
  infoCard,
  sx,
  children
}: ItemListCardProps) => {
  return (
    <ContentCard
      title={title}
      titleVariant={titleVariant}
      subtitle={subtitle}
      sx={{ px: 3, pt: 2.5, ...sx }}
    >
      {children}

      {isEmpty && emptyStateText && (
        <Typography variant="body2">{emptyStateText}</Typography>
      )}

      {showAddButton && (
        <ButtonContainer sx={{ pt: 3, px: 0 }}>
          <Button
            fullWidth
            data-testid={addButtonTestId}
            color="secondary"
            variant="contained"
            onClick={onAddClick}
            sx={{ minWidth: 252, ...addButtonSx }}
          >
            {addButtonLabel}
          </Button>
        </ButtonContainer>
      )}

      {isEmpty && infoCard && (
        <InfoCard sx={{ mt: 3 }}>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {infoCard.title}
          </Typography>
          <Typography variant="body2">{infoCard.body}</Typography>
        </InfoCard>
      )}
    </ContentCard>
  );
};
